
import { FC } from 'react';

export interface IInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  validation?: 'error' | undefined;
  validationMsg?: string;
}

export const Input: FC<IInputProps> = ({ onChange, value, validation, validationMsg, name, ...rest }) => {
  let classes = "cb-input cb-btn-input cb-clear-input cb-value-ci";
  if (validation === 'error') {
    classes += ' cb-validation-error';
  }

  return <>
    <div className={classes}>
      <div className="cb-validation-label-input">
        <input onChange={onChange} {...rest} name={name} value={value || ''} />
        {/* <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale">
        <span className="cb-icon cb-x-mark" aria-hidden="true"></span><span className="sr-only">Clear</span>
      </button> */}
      </div>
      {validation === 'error' &&
        <i className="cb-validation-icon cb-icon cb-exclamation" aria-hidden="true"></i>
      }
    </div>
    {validation === 'error' &&
      <p className="cb-input-helper cb-validation-error">{validationMsg || ''}</p>
    }
  </>;
};

